import { ReactNode, useSyncExternalStore } from "react";
import { subscribeEngagement, getEngagementSnapshot, getServerEngagementSnapshot } from "@/lib/engagement";

/** Legacy timeout argument is deliberately ignored: only real engagement unlocks work. */
export function useInteractionReady(_idleTimeoutMs?: number) {
  return useSyncExternalStore(subscribeEngagement, getEngagementSnapshot, getServerEngagementSnapshot);
}

interface InteractionGateProps {
  children: ReactNode;
  /** Rendered before the gate fires. Useful to reserve height and avoid layout jump. */
  placeholder?: ReactNode;
  /** Deprecated compatibility prop; idle time never opens this gate. */
  idleTimeoutMs?: number | undefined;
}

/** Defers enhancements without gating the initial page, header or theme. */
export default function InteractionGate({
  children,
  placeholder = null,
}: InteractionGateProps) {
  const activated = useInteractionReady();
  return activated ? <>{children}</> : <>{placeholder}</>;
}
